import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, Avatar, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import {
    List, Datagrid, TextField, FunctionField,
    useRefresh, SimpleList
} from 'react-admin';
import { useDispatch } from "react-redux";
import queryString from 'query-string';
import moment from "moment";
import { vehicleSvgs, hideMobileNumber, hideVehicleNumber, hideName } from "./sharedData";
import { customTheme } from './customTheme';
// import SortOption from "./components/SortOption";
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
// import DeleteIcon from '@material-ui/icons/Delete';


const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    timeFilterContainer: {
        alignItems: "center",
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    listToolbar: {
        alignItems: "flex-end",
        marginTop: 10
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "block",
        borderRadius: 50,
        minWidth: 100,
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "15px 15px 15px",
        maxWidth: 350
    },
});

const VALET_PASS_COLUMN = {
    "Parking Name": false,
    "Price": false,
    "Issue On": false,
    "Issued By": false,
    "Pass Type": false,
    "Renewal Date": true,
    "Expiry Date": true,
};

const CATEGORY = "VALET PASS SECTION"

const renderAmount = (row, fieldName) => (`₹ ${parseFloat(row[fieldName])}`);
const renderVehicleType = (row) => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

export function ValetPass(props) {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const listDataRef = useRef()
    const queryParams = queryString.parse(props.location.search);
    let [prevSearch] = useState(queryParams && queryParams.vehicle_number ? { inputSearch: queryParams.vehicle_number, type: "Vehicle Number" } : sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const dispatch = useDispatch();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [allowEdit] = React.useState(sessionStorage.getItem("allow_edit_monthly_pass") === "1");
    const [allowRecharge] = React.useState(sessionStorage.getItem("allow_pass_recharge") === "1");
    const [allowDelete] = React.useState(sessionStorage.getItem("allow_pass_delete") === "1");
    // const [setAllowRedirect] = React.useState(true);
    const [displayColumns, setDisplayColumns] = useState(sessionStorage.getItem("valetPassUserColumns") ? JSON.parse(sessionStorage.getItem("valetPassUserColumns")) : VALET_PASS_COLUMN);
    //const [vehicleTypes, setVehicleTypes] = React.useState(Object.keys(featuresData.vehicle_type).map(type => ({ type, label: featuresData.vehicle_type[type].label, name: featuresData.vehicle_type[type].name })));
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Name", "Mobile", "Pass Type", "Issue By"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [

        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "Issued On": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined }
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        return moment(time).utcOffset("+05:30").format(`DD MMM YYYY ${use24HourFormat ? `HH:mm${secondsFormat} A` : `hh:mm${secondsFormat} a`}`)
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    // const openVehicleLogs = (id, basePath, record) => `/monthlyPassLog?${queryString.stringify({ vehicle_number: record.vehicle_number })}`;

    const renderStatus = record => (
        <>
            {
                record ?
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: record.expiry_date > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59") ? `${customTheme.palette.primary.main}19` : `${customTheme.palette.error.main}19`, marginRight: 8 }}>
                            <div className={classes.statusCircle} style={{ backgroundColor: record.expiry_date > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59") ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
                        </div>
                        <p>{renderTime(record.expiry_date)}</p>
                    </div>
                    :
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#9597991a", marginRight: 8 }}>
                        <div className={classes.statusCircle} style={{ backgroundColor: "#1717181f" }} />
                    </div>
            }
        </>
    );

    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Display Columns") {
                    values = { ...values, columns: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, "VALET PASS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className={classes.list}>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={VALET_PASS_COLUMN} storageKey="valetPassUserColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
            </div>
            <List
                style={{ marginTop: 20 }}
                filter={filter}
                sort={{ field: "expiry_date", order: "DESC" }}
                empty={false}
                {...props}
                actions={false}
                bulkActionButtons={false}
                pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
            >
                {isSmallDevice ?
                    <SimpleList
                        leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} />}
                        primaryText={record => hideVehicleNumber(record.vehicle_number.toUpperCase())}
                        secondaryText={record => (<div>
                            <div style={{ color: customTheme.palette.secondary.main }}>{record.parking_name}</div>
                            {record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
                            {record.mobile_number && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{hideMobileNumber(record.mobile_number)}</div>}
                            {record.issued_by_user_id && <div><span style={{ color: "#5a5a5a" }}>Issued By: </span>{record.issued_by_user_id}</div>}
                            {record.issue_time && <div><span style={{ color: "#5a5a5a" }}>Issued on: </span>{renderTime(record.issue_time)}</div>}
                            {record.last_start_date && <div><span style={{ color: "#5a5a5a" }}>Renewal Date: </span>{renderTime(record.last_start_date)}</div>}
                            {record.expiry && <div><span style={{ color: "#5a5a5a" }}>Expiry: </span>{renderTime(record.expiry_date)}</div>}
                            {record.pass_type && <div><span style={{ color: "#5a5a5a" }}>Pass Type: </span>{record.pass_type}</div>}
                            {record.price && record.price !== "" && !isNaN(record.price) && <div><span style={{ color: "#5a5a5a" }}>Price: </span>₹{parseFloat(record.price)}</div>}
                        </div>)}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <FunctionField label="Vehicle number" render={record =>
                            <div style={{ color: "#334d6e", fontWeight: "bold" }}>
                                {record && record.vehicle_number ? hideVehicleNumber(record.vehicle_number.toUpperCase()) : '-'}
                            </div>} />
                        <FunctionField
                            label="Vehicle Type"
                            render={renderVehicleType}
                        />
                        <FunctionField source="mobile_number" label="Mobile" sortable={false} render={record => record && record["mobile_number"] && record["mobile_number"] !== null ? hideMobileNumber(record.mobile_number) : "-"} />
                        <FunctionField source='name' label='Name' sortable={false} render={(record) => record && record.name ? hideName(record.name) : '-'} />
                        {displayColumns["Parking Name"] && <TextField source="parking_name" sortable={false} />}
                        {displayColumns["Issued By"] && <TextField source="issued_by_user_id" sortable={false} label="Issued By" />}
                        {displayColumns["Issue On"] && <FunctionField source="issue_time" label="Issued on" sortable={false} render={record => record && record.issue_time ? renderTime(record.issue_time) : '-'} />}
                        {displayColumns["Renewal Date"] && <FunctionField source="last_start_date" label="Renewal Date" sortable={false} render={record => record && record.last_start_date ? renderTime(record.last_start_date) : '-'} />}
                        {displayColumns["Expiry Date"] && <FunctionField
                            source="expiry_date"
                            label="Validity"
                            render={record => record && renderStatus(record)}
                        />}
                        {displayColumns["Price"] && <FunctionField label="Price" source="price" sortable={false} render={(record) => renderAmount(record, "price")} />}
                        {displayColumns["Pass Type"] && <TextField source="pass_type" sortable={false} />}

                    </Datagrid>
                }
            </List>
        </div>
    );
};